import { render } from "@/components/pages/individualWorkSupport/requirement004/Requirement004.html?vue&type=template&id=67ef1383&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement004/Requirement004.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement004/Requirement004.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement004/Requirement004.scss?vue&type=style&index=0&id=67ef1383&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ef1383"]])

export default __exports__